import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import PropTypes from "prop-types";

const CurriculumCard = ({ curriculum }) => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 300 });
  }, []);
  return (
    <div
      data-aos="flip-down"
      className="bg-white my-4 lg:my-8 p-3 xl:p-6 relative border-2 border-black border-opacity-10 curriculum_card"
      style={{ borderRadius: "8px" }}
    >
      <div>
        <h1 className="sys_primary uppercase font-bold">{curriculum.title}</h1>
        {curriculum.subtitles && (
          <div className="ml-3 mt-3 xl:ml-6 xl:mt-6">
            {curriculum.subtitles.map((subtitle, i) => {
              return (
                <div key={i} className="flex">
                  <img src="/assets/icons/tick_2.svg" alt="" />
                  <p className="ml-2 my-2">{subtitle}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <p
        className="sys_bg_primary text-white bottom-0 absolute w-full -mx-3 xl:-mx-6 px-3 xl:px-6 flex flex-col font-bold justify-center"
        style={{
          height: "48px",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
        }}
      >
        Day {curriculum.day}
      </p>
    </div>
  );
};

CurriculumCard.propTypes = {
  curriculum: PropTypes.object,
};

export default CurriculumCard;
